/**
 *
 * Using the reserveStatus from CMS return the button type
 */

import { ReserveStatus } from '../../types';
import { ButtonType } from './types';

interface InventoryBasedProps {
  noCarriers: boolean;
  reservableCarrierExists: boolean;
}

const getInventoryBasedStatus = ({
  noCarriers,
  reservableCarrierExists,
}: InventoryBasedProps): ButtonType | undefined => {
  if (reservableCarrierExists) {
    return ButtonType.Reserve;
  }
  if (!reservableCarrierExists && !noCarriers) {
    // No reservable carrier, but we do have items to display
    return ButtonType.Chat;
  }
  return undefined;
};

interface Props {
  reserveStatus: ReserveStatus;
  noCarriers: boolean;
  reservableCarrierExists: boolean;
}

/*
  Gets the Phone's Button Type using the inventory matrix provided in TMSP-1564
  @param reserveStatus
  The status set in CMS for the Phone (inventory, chat etc)
  @param carriersExist
  True if carriers are displayed
  @param reservableCarrierExists
  True if there is at least one reservable carrier (Limited, Reservable)
*/
const getPhoneReserveButtonType = ({
  reserveStatus,
  noCarriers,
  reservableCarrierExists,
}: Props): ButtonType | undefined => {
  switch (reserveStatus) {
    case ReserveStatus.ChatWithMobilist:
      return ButtonType.Chat;
    case ReserveStatus.Always:
      return ButtonType.Reserve;
    case ReserveStatus.InventoryBased:
      // Inventory based
      return getInventoryBasedStatus({
        noCarriers,
        reservableCarrierExists,
      });
    default:
      return undefined;
  }
};

export default getPhoneReserveButtonType;
